// extracted by mini-css-extract-plugin
export default {"productGallery":"yG-z","inQuickShop":"zG-z"};